import { FormattedMessage } from "react-intl";
import Navbar from "../../../components/Navbar";
import { motion } from "framer-motion";
import { ballMotion } from "../../../animations/framer";
import Polaroid from "./Polaroid";

const style = {
	aboutWrapper: `relative py-4 lg:flex lg:items-center lg:py-0 lg:gap-[10vw] lg:min-h-screen`,
	imgWrapper: `flex justify-center items-center py-5 flex-col lg:basis-1/2 lg:py-0 lg:justify-start`,
	imgNeon: `relative z-10`,
	neonBlue: `absolute top-[30%] -z-10 left-[0] shadow-[0px_0px_160px_80px_#4430D0]`,
	neonLime: `absolute top-[40%] -z-10 right-[0] shadow-[0px_0px_160px_80px_#DAF66A]`,
	img: `w-[200px] h-[200px] overflow-hidden rounded-full lg:rounded-md lg:w-[300px] lg:h-[300px]`,
	title: `text-5xl tracking-wide vasek mb-8`,
	textWrapper: `relative flex flex-col items-center text-center gap-4 text-lg lg:items-start lg:text-left lg:basis-1/2`,
	redLine: `underline underline-offset-4 decoration-red decoration-3`,
	limeLine: `underline underline-offset-4 decoration-lime decoration-3`,
	courseLogo: `flex items-center justify-center`,
	circle: `w-[70px] animate-spin-slow`,
	restart: `w-[200px]`,
};

const About = () => {
	return (
		<div className={style.aboutWrapper}>
			<div className={style.textWrapper}>
				<div className={style.courseLogo}>
					<img
						className={style.circle}
						src='./images/restartCircle.png'
						alt='circle'
					/>
					<img
						className={style.restart}
						src='./images/restartText.png'
						alt='Restart'
					/>
				</div>
				<Navbar />
				<h2 className={style.title}>
					<FormattedMessage id='main.name' />
				</h2>
				<p className={style.text}>
					<FormattedMessage
						id='main.role'
						values={{
							b: (chunks) => (
								<strong style={{ color: "#DAF66A" }}>{chunks}</strong>
							),
						}}
					/>
				</p>
				<p className={style.text}>
					<FormattedMessage id='main.about-one' />
				</p>
				<p className={style.text}>
					<FormattedMessage id='main.about-two' />
				</p>
				<p className={style.text}>
					<FormattedMessage
						id='main.about-three'
						values={{
							b: (chunks) => (
								<strong style={{ color: "#4430D0" }}>{chunks}</strong>
							),
						}}
					/>
				</p>
			</div>
			<div className={style.imgWrapper}>
				<div className={style.imgNeon}>
					<Polaroid />
					<motion.div
						variants={ballMotion}
						animate='startone'
						className={style.neonBlue}
					></motion.div>
					<motion.div
						variants={ballMotion}
						animate='starttwo'
						className={style.neonLime}
					></motion.div>
				</div>
			</div>
		</div>
	);
};

export default About;
